import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';

import Reducer from './Reducer';
import initialState from './InitialState';

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>;
};

Store.propTypes = {
  children: PropTypes.node.isRequired,
};

export const Context = createContext(initialState);
export default Store;
